<template>
  <div class="grid-content loading" v-loading="loading">
    <table class="area-header">
      <tr>
        <td v-if="!readonly" class="area-header-part1">
          <el-button size="medium" type="primary" plain icon="el-icon-plus" :disabled="loading" @click="addSAPService">添加业务</el-button>
          <el-button size="medium" :disabled="loading" type="primary" :loading="saveLoading" @click="saveChanges">保存更新</el-button>
          <el-button size="medium" :disabled="loading" type="primary" icon="el-icon-upload2" @click="showImportExcel">导入</el-button>
          <el-button size="medium" :disabled="exportLoading" :loading="exportLoading" type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
        </td>
        <td v-if="mode === 'normal'" class="area-header-part2">
          <div class="tips">
            <span>估算佣金比例：{{Object.toPercent(this.estimatedCommission)}}</span>
          </div>
        </td>
      </tr>
    </table>
    <el-collapse class="area-main" v-model="activeCollapses" accordion>
      <div class="price-area" v-for="(item, index) in sapServiceList.filter(m => m.Enable)" :key="index" :name="item.Name">
        <sapService key="sapService" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com, index)" :mode="mode"
          :isActive="activeCollapses === item.CollapseName" :readonly="readonly" :estimatedCommission="estimatedCommission" :data="item" :index="index"
          @delete="deleteSAPService" />
      </div>
    </el-collapse>
    <el-row v-if="!readonly" class="area-footer">
      <el-col :span="4" class="footer-left">
        <el-button size="medium" :disabled="loading" type="primary" :loading="saveLoading" @click="saveChanges">保存更新</el-button>
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
      </el-col>
    </el-row>

    <el-dialog center title="导入" :show-close="true" :close-on-click-modal="false" width="700px" v-if="uploaderModel.visible" :visible.sync="uploaderModel.visible" top="8vh" z-index="2000">
      <fileUploader v-on:closeEditor="onCloseEditor" v-on:fileUploaded="onFileUploaded" @fileBeforeUpload="onFileBeforeUpload"
        @fileUploadError="onFileUploadError" :submitBtnText="'确认导入'" :isVisible="uploaderModel.visible" :limit="1"
        :accepts="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;application/wps-office.xlsx'" :tips="'只能上传格式为.xlsx的文件'"
        :type="{type:'StudyAbroadPlanPrice'}" :supportedFile="'.xlsx'" :customizeUploader="customizeUploader"></fileUploader>
    </el-dialog>
  </div>

</template>

<script>
import { guid, downloadFile } from "@/config/mUtils";
import {
  getStudyAbroadPlanServiceList,
  saveStudyAbroadPlanServices,
  exportStudyAboardServices,
  uploadExcelForStudyAboardServiceImport,
} from "@/service/studyAbroad.service";

const defaultSAPServiceModel = {
  Id: 0,
  Enable: true,
  Name: null,
  CommissionType: 1,
  ServiceItems: [],
};

export default {
  name: "sapPrice",
  components: {
    sapService: () => import("./sapService"),
    fileUploader: () => import("@/components/fileHandler/fileUploader"),
  },
  props: {
    mode: {
      type: String,
      default: "normal",
      validator: (value) => ["normal", "bottomPrice"].contains(value),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      saveLoading: false,
      exportLoading: false,
      showError: false,
      errorMessage: "",
      estimatedCommission: 0.3,
      activeCollapses: "",
      sapServiceList: [],
      uploaderModel: {
        visible: false,
        closeVisible: false,
      },
    };
  },
  created() {
    this.loadStudyAbroadPlanServiceListFromServer();
  },
  methods: {
    customizeUploader(param) {
      var formData = new FormData();

      formData.append("file", param.file, param.file.name);
      formData.append("type", "StudyAbroadPlanPrice");

      uploadExcelForStudyAboardServiceImport(formData)
        .then((rs) => {
          if (rs.error) {
            param.onError({
              message: '{"Message": "导入失败: ' + rs.error + '"}',
            });
            return;
          }

          if (rs.body.type == "application/json") {
            rs.body.text().then((rs) => {
              rs = JSON.parse(rs);

              if (!rs.success) {
                param.onError({
                  message: '{"Message": "' + rs.message + '"}',
                });
              } else if (typeof rs === "string") {
                param.onSuccess(JSON.parse(rs));
              } else {
                param.onSuccess(rs);
              }

              param.onSuccess(rs);
            });
          } else {
            downloadFile({ data: rs.body, filename: rs.filename });

            param.onError({
              message:
                '{"Message": "导入文件存在问题, 文件已经回退给您, 请根据文件中每行最右侧的错误信息修正内容之后再试"}',
            });
          }
        })
        .catch((reason) => {});
    },
    async showImportExcel() {
      this.uploaderModel.visible = true;
    },
    exportExcel() {
      this.exportLoading = true;
      this.loading = true;

      exportStudyAboardServices()
      .then((result) => {
        downloadFile(result);

        this.exportLoading = false;
        this.loading = false;
      })
      .catch((err) => {
        this.exportLoading = false;
        this.loading = false;
      });
    },
    onCloseEditor() {
      this.uploaderModel.visible = false;
      this.uploaderModel.closeVisible = true;
    },
    onFileBeforeUpload() {
      this.uploaderModel.closeVisible = false;
    },
    onFileUploadError() {
      this.uploaderModel.closeVisible = true;

      this.$message.error("导入数据失败。");
    },
    onFileUploaded(res) {
      this.uploaderModel.visible = false;
      this.uploaderModel.closeVisible = true;

      if (!res.success) {
        this.$message.success("导入失败: " + res.message);
      } else {
        this.$message.success("导入数据成功。");
        this.loadStudyAbroadPlanServiceListFromServer();
      }
    },

    async loadStudyAbroadPlanServiceListFromServer() {
      this.loading = true;
      let result = await getStudyAbroadPlanServiceList();
      this.sapServiceList = !!result && result.success ? result.data : [];
      this.sapServiceList.forEach((item) => {
        item.CollapseName = `Service_${item.Id}`;
      });

      if (this.sapServiceList.length > 0) {
        this.activeCollapses = this.sapServiceList[0].CollapseName;
      }

      this.$nextTick(() => {
        this.loading = false;
      });
    },
    async saveStudyAbroadPlanServicesToServer() {
      this.saveLoading = true;
      this.loading = true;
      try {
        await this.fixSAPServiceList();
        let result = await saveStudyAbroadPlanServices(this.sapServiceList);
        if (!result || !result.success) {
          this.$message.error({
            dangerouslyUseHTMLString: true,
            message: result.message.toHtml(),
          });
          return;
        }

        this.$message({
          message: "真留计划价格信息保存成功",
          type: "success",
        });
        await this.loadStudyAbroadPlanServiceListFromServer();
        this.$emit("valueChange", false);
      } catch (error) {
        console.error(error);
      } finally {
        this.saveLoading = false;
        this.loading = false;
      }
    },
    addSAPService() {
      let newDataModel = Object.clone(defaultSAPServiceModel);
      newDataModel.CollapseName = `Service_${guid()}`;
      this.sapServiceList.insert(0, newDataModel);

      this.$nextTick(() => {
        this.activeCollapses = newDataModel.CollapseName;
      });
    },
    deleteSAPService(dataModel) {
      if (!dataModel.Id) {
        this.sapServiceList.remove(dataModel);
        return;
      }

      dataModel.Enable = false;
    },
    validate() {
      let isValid = true;

      let refComList = this.$vueRefStore.getChildrenRefs("sapService");
      if (!!refComList && refComList.length > 0) {
        refComList.forEach((com) => {
          let result = com.validate();
          if (isValid) isValid = result;
        });
      }

      return isValid;
    },
    fixSAPServiceList() {
      this.sapServiceList.forEach((service) => {
        service.ServiceItems.forEach((serviceItem) => {
          if (Object.typeOf(serviceItem.SalePriceCAD) !== "number")
            serviceItem.SalePriceCAD = `${serviceItem.SalePriceCAD}`.toNumber();
          if (Object.typeOf(serviceItem.SalePriceCNY) !== "number")
            serviceItem.SalePriceCNY = `${serviceItem.SalePriceCNY}`.toNumber();
          if (Object.typeOf(serviceItem.BottomPriceCAD) !== "number")
            serviceItem.BottomPriceCAD = `${serviceItem.BottomPriceCAD}`.toNumber();
          if (Object.typeOf(serviceItem.BottomPriceCNY) !== "number")
            serviceItem.BottomPriceCNY = `${serviceItem.BottomPriceCNY}`.toNumber();

          serviceItem.PriceCategoryInfos.forEach((pcInfo) => {
            if (Object.typeOf(pcInfo.SalePriceCAD) !== "number")
            pcInfo.SalePriceCAD = `${pcInfo.SalePriceCAD}`.toNumber();
            if (Object.typeOf(pcInfo.SalePriceCNY) !== "number")
              pcInfo.SalePriceCNY = `${pcInfo.SalePriceCNY}`.toNumber();
            if (Object.typeOf(pcInfo.BottomPriceCAD) !== "number")
              pcInfo.BottomPriceCAD = `${pcInfo.BottomPriceCAD}`.toNumber();
            if (Object.typeOf(pcInfo.BottomPriceCNY) !== "number")
              pcInfo.BottomPriceCNY = `${pcInfo.BottomPriceCNY}`.toNumber();
          });
        });
      });
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) {
        return;
      }

      this.$nextTick(async () => {
        await this.saveStudyAbroadPlanServicesToServer();
      });
    },
  },
  watch: {
    sapServiceList: {
      handler(newName, oldName) {
        if (!this.loading) {
          this.$emit("valueChange", true);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.area-header {
  width: 100%;

  .area-header-part2 {
    text-align: right;

    .tips {
      display: inline-block;
      line-height: 36px;
      height: 36px;
    }
  }
}

.area-main {
  border-top: 0;
  border-bottom: 0;
}

.area-main,
.area-footer {
  margin: 40px 0 0 0;
}

.price-area {
  margin-top: 30px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/priceManagement/sapPrice.vue